<template>
  <div class="col-xs-12 beware">
    <span>{{ trans('subscription.subscribable_groupings.beware_edit') }}</span>
  </div>
</template>

<script>
export default {
  name: 'BewareEdit',
}
</script>

<style>
    .beware {
        color: red;
        margin-bottom: 10px;
    }
</style>
